import {
    faChevronLeft,
    faChevronRight,
    faSpinner,
    faTimes,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import { Location } from "history";
import React from "react";
import { MapStateToPropsParam } from "react-redux";

import { toastAdd } from "@/mk2/actions";
import { bazaarNavigationLoad } from "@/mk2/apps/bazaar/actions";
import { MessageFormData } from "@/mk2/apps/bazaar/components/MessageForm";
import { ReviewFormData } from "@/mk2/apps/bazaar/components/ReviewForm";
import isSoldPollReducer from "@/mk2/apps/bazaar/containers/IsSoldPoll/IsSoldPoll.reducers";
import isSoldPollSaga from "@/mk2/apps/bazaar/containers/IsSoldPoll/IsSoldPoll.sagas";
import ProductDetail from "@/mk2/apps/bazaar/containers/ProductDetail/ProductDetail";
import {
    productDetailActivateProduct,
    productDetailDeactivateProduct,
    productDetailDeleteProduct,
    productDetailLoad,
    productDetailLoadRelatedProducts,
    productDetailMarkOKProduct,
    productDetailNewMessage,
    productDetailNewReply,
    productDetailNewReview,
    productDetailReadMessages,
    productDetailRemoveBuyer,
    productDetailReportProduct,
    productDetailRepostProduct,
    productDetailRestoreBuyer,
    productDetailSetShowSellerPhone,
    productDetailUndeleteProduct,
    productDetailView,
} from "@/mk2/apps/bazaar/containers/ProductDetail/ProductDetail.actions";
import reducer from "@/mk2/apps/bazaar/containers/ProductDetail/ProductDetail.reducers";
import saga from "@/mk2/apps/bazaar/containers/ProductDetail/ProductDetail.sagas";
import {
    getProductDetailProductState,
    getProductDetailState,
} from "@/mk2/apps/bazaar/containers/ProductDetail/ProductDetail.selectors";
import { paramsToSlug, slugToParams } from "@/mk2/apps/bazaar/helpers";
import navigationReducer from "@/mk2/apps/bazaar/reducers/navigation";
import navigationSaga from "@/mk2/apps/bazaar/sagas/navigation";
import {
    BazaarMessageEntity,
    BazaarMessageSchema,
    BuyerEntity,
    BuyerSchema,
    DeletedReason,
    MarkEntity,
    MarkSchema,
    ProductEntity,
    ProductSchema,
    ReviewEntity,
    ReviewSchema,
} from "@/mk2/apps/bazaar/schemas";
import { getBazaarNavigationState } from "@/mk2/apps/bazaar/selectors/navigation";
import {
    breadcrumbsProduct,
    product as productStructuredData,
} from "@/mk2/apps/bazaar/structuredData";
import { bazaarProductDetailUrl } from "@/mk2/apps/bazaar/urls";
import { NoteEntity, NoteSchema } from "@/mk2/apps/notes/schemas";
import { Btn, BtnLayout } from "@/mk2/components/Btn";
import { Link } from "@/mk2/components/Link";
import { ServerErrorToast } from "@/mk2/components/toasts/ServerErrorToast";
import { AppName } from "@/mk2/containers/Application/Application";
import { ComplaintEntity, ComplaintTargetType } from "@/mk2/containers/Complaint/Complaint.schemas";
import { findComplaintsNonDeleted } from "@/mk2/containers/Complaints/Complaints.selectors";
import { MapDispatchToPropsObject } from "@/mk2/helpers/types";
import { url } from "@/mk2/helpers/urls";
import Page, {
    AnchorLeaderboardProps,
    BrandingProps,
    InterstitialProps,
    PageRouteProps,
} from "@/mk2/pages/Page";
import {
    AppState,
    getRequestBaseUrl,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
} from "@/mk2/reducers";
import { LoadingState } from "@/mk2/reducers/loadingState";
import { MenuSelection, StrollerEntity, StrollerSchema, UserEntity } from "@/mk2/schemas";
import {
    findDenormalizedEntitiesByCond,
    findDenormalizedEntityByCond,
    getDenormalizedEntities,
    getDenormalizedEntity,
} from "@/mk2/selectors";
import { HistoryLocationWithState } from "@/mk2/services/browserHistory";
import { Store } from "@/mk2/store/configureStore";
import { BAZAAR_SEO_BABY, FROM_SELLER } from "@/mk/autogenerated/translation";
import { formatPrice, formatThousands } from "@/mk/bazaar/common/formatters";
import { hasAds } from "@/mk/bazaar/common/userUtils";
import { dict, isLeafCategory } from "@/mk/bazaar/product/categories";
import { photoUrl } from "@/mk/photo/photoUrl";

import styles from "./ProductDetailPage.mscss";

const emptyArray = [];

export interface OwnProps {}

export interface StateProps {
    requestUser: UserEntity;
    requestUserPermissions: string[];
    loadingState: LoadingState;
    errorMessage: string;
    product: ProductEntity;
    baseUrl: string;
    hits: number;
    index: number;
    nextProduct?: ProductEntity;
    previousProduct?: ProductEntity;
    back: Location;
    complaints: ComplaintEntity[];
    marks: MarkEntity[];
    messages: BazaarMessageEntity[];
    reviews: ReviewEntity[];
    buyers: BuyerEntity[];
    closedBuyers: BuyerEntity[];
    relatedProducts: ProductEntity[];
    isMobile: boolean;
    activatingProductIds: number[];
    deactivatingProductIds: number[];
    deletingProductIds: number[];
    undeletingProductIds: number[];
    repostingProductIds: number[];
    markingOKProductIds: number[];
    lastNote: NoteEntity;
    loadedAt: number;
    sellerPhone: string;
    relatedProductsHasNext: boolean;
    relatedProductsLoadingState: LoadingState;
    stroller: StrollerEntity;
    strollerReviewedBySeller: boolean;
    viewsCount: number;
    historyCount: number;
}

export interface DispatchProps {
    onLoad(slug: string);
    onLoadRelatedProducts(slug: string, start: number);
    onActivate(productId: number);
    onDeactivate(productId: number);
    onRepost(productId: number);
    onReport(productId: number, location: HistoryLocationWithState);
    onMarkOK(productId: number);
    onDelete(productId: number, reason?: DeletedReason);
    onUndelete(productId: number);
    onNewMessage(productId: number, productSlug: string, data: MessageFormData);
    onNewReview(buyerId: number, productSlug: string, data: ReviewFormData);
    onNewReply(buyerId: number, productSlug: string, data: MessageFormData);
    onReadMessages(messagesIds: number[]);
    onRemoveBuyer(slug: string, buyerId: number);
    onRestoreBuyer(slug: string, buyerId: number);
    onView(productId: number, productSlug: string);
    onSetShowSellerPhone(value: boolean, slug: string, phoneVerified: boolean, sellerId: number);
    onFailureToast();
    onNavigationLoad(productId: number, location: HistoryLocationWithState);
}

export type RouteProps = PageRouteProps<{
    category: string;
    hash: string;
    title: string;
}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class ProductDetailPage extends Page<OwnProps, StateProps, DispatchProps> {
    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const { routeParams } = ownProps;
            const slug = paramsToSlug(routeParams);
            const substate = getProductDetailState(state);
            const productState = getProductDetailProductState(state, slug);

            const product = findDenormalizedEntityByCond<ProductEntity>(
                state,
                ProductSchema,
                `cacheKey-ProductDetailPage-${slug}-product`,
                (sel) => sel.slug === slug || sel.slugsHistory?.includes(slug),
            );

            const marks =
                (product &&
                    findDenormalizedEntitiesByCond<MarkEntity>(
                        state,
                        MarkSchema,
                        `cacheKey-ProductDetailPage-${slug}-marks`,
                        (sel) => sel.targetId === product.id,
                    )) ||
                emptyArray;

            const complaints =
                (product &&
                    findComplaintsNonDeleted(
                        state,
                        ComplaintTargetType.BazaarProduct,
                        product.id,
                    )) ||
                emptyArray;

            const requestUserPermissions = getRequestPermissions(state);

            const navigationState = getBazaarNavigationState(state);
            const navigationIndex = parseInt(
                !product
                    ? "-1"
                    : Object.keys(navigationState.ids).find(
                          (i) => navigationState.ids[i] === product.id,
                      ) || "-1",
                10,
            );
            const nextProductId =
                navigationIndex < navigationState.hits && navigationState.ids[navigationIndex + 1];
            const previousProductId =
                navigationIndex > 0 && navigationState.ids[navigationIndex - 1];

            return {
                requestUser: getRequestUser(state),
                requestUserPermissions,
                loadingState: productState.loadingState,
                errorMessage: productState.errorMessage,
                product,
                baseUrl: getRequestBaseUrl(state),
                hits: navigationState.hits,
                index: navigationIndex,
                back: navigationState.back,
                nextProduct: nextProductId
                    ? getDenormalizedEntity<ProductEntity>(state, ProductSchema, nextProductId)
                    : null,
                previousProduct: previousProductId
                    ? getDenormalizedEntity<ProductEntity>(state, ProductSchema, previousProductId)
                    : null,
                marks,
                complaints,
                messages: getDenormalizedEntities<BazaarMessageEntity>(
                    state,
                    BazaarMessageSchema,
                    productState.messagesIds,
                ),
                buyers: getDenormalizedEntities<BuyerEntity>(
                    state,
                    BuyerSchema,
                    productState.buyersIds,
                ),
                reviews: getDenormalizedEntities<ReviewEntity>(
                    state,
                    ReviewSchema,
                    productState.reviewsIds,
                ),
                closedBuyers: getDenormalizedEntities<BuyerEntity>(
                    state,
                    BuyerSchema,
                    productState.closedBuyersIds,
                ),
                relatedProducts: getDenormalizedEntities<ProductEntity>(
                    state,
                    ProductSchema,
                    productState.relatedProductsIds,
                ),
                relatedProductsHasNext: productState.relatedProductsHasNext,
                relatedProductsLoadingState: productState.relatedProductsLoadingState,
                isMobile: getRequestDeviceMobile(state),
                activatingProductIds: substate.activatingProductIds,
                deactivatingProductIds: substate.deactivatingProductIds,
                deletingProductIds: substate.deletingProductIds,
                undeletingProductIds: substate.undeletingProductIds,
                repostingProductIds: substate.repostingProductIds,
                markingOKProductIds: substate.markingOKProductIds,
                lastNote: getDenormalizedEntity<NoteEntity>(
                    state,
                    NoteSchema,
                    productState.lastNoteId,
                ),
                loadedAt: productState.loadedAt,
                sellerPhone: productState.sellerPhone,
                stroller:
                    productState.strollerId &&
                    getDenormalizedEntity<StrollerEntity>(
                        state,
                        StrollerSchema,
                        productState.strollerId,
                    ),
                strollerReviewedBySeller: productState.strollerReviewedBySeller,
                viewsCount: productState.viewsCount,
                historyCount: productState.historyCount,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: productDetailLoad,
            onLoadRelatedProducts: productDetailLoadRelatedProducts,
            onActivate: productDetailActivateProduct,
            onDeactivate: productDetailDeactivateProduct,
            onDelete: productDetailDeleteProduct,
            onUndelete: productDetailUndeleteProduct,
            onRepost: productDetailRepostProduct,
            onReport: productDetailReportProduct,
            onMarkOK: productDetailMarkOKProduct,
            onNewMessage: productDetailNewMessage,
            onReadMessages: productDetailReadMessages,
            onNewReview: productDetailNewReview,
            onNewReply: productDetailNewReply,
            onRemoveBuyer: productDetailRemoveBuyer,
            onRestoreBuyer: productDetailRestoreBuyer,
            onView: productDetailView,
            onSetShowSellerPhone: productDetailSetShowSellerPhone,
            onNavigationLoad: bazaarNavigationLoad,
            onFailureToast: () =>
                toastAdd("error", {
                    component: ServerErrorToast,
                }),
        };
    }

    public getMetaTitle(props: Props): string {
        const { product } = props;

        if (!product) {
            return `${BAZAAR_SEO_BABY}`;
        }

        const title = `${product.seo.name} - ${formatPrice(product.price)} ${FROM_SELLER} ${
            product.seller?.user?.username
        }`;
        return `${title} | ${BAZAAR_SEO_BABY}`;
    }

    public getMetaDescription(props: Props): string {
        const { product } = props;

        if (!product) {
            return super.getMetaDescription(props);
        }

        return product.seo.description;
    }

    public getOpenGraphData(
        props: Props,
        baseUrl: string,
        currentUrl: string,
    ): { [p: string]: string | string[] } {
        const { product } = props;

        if (!product) {
            return super.getOpenGraphData(props, baseUrl, currentUrl);
        }

        const ret = {
            ...super.getOpenGraphData(props, baseUrl, currentUrl),
            "og:title": product.seo.name,
            "og:description": product.seo.description,
            "og:url": baseUrl + url(bazaarProductDetailUrl, slugToParams(product.slug)),
            "og:image": [],
        };

        if (product.photos.length > 1) {
            product.photos
                ?.slice(1)
                .filter(Boolean)
                .map((p) => p.photofile)
                .forEach((photoEntity) => {
                    const hasBig = photoEntity.versions.indexOf("s1600x1600") !== -1;
                    const smallUrl = photoUrl(photoEntity, "s460xn");
                    const bigUrl = photoUrl(photoEntity, "s1600x1600");

                    ret["og:image"].push(`${hasBig ? bigUrl : smallUrl}`);
                });
        }

        return ret;
    }

    public render(props: Props): false | JSX.Element {
        return <ProductDetail {...props} />;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getHeaderLeft(props: Props): JSX.Element {
        const { index, back, isMobile } = props;
        if (index >= 0 && isMobile) {
            return (
                <Btn
                    layout={BtnLayout.Icon}
                    link={back}
                    linkState={{
                        dontScrollOnPush: true,
                        fromProductDetail: true,
                    }}
                    icon={faTimes}
                />
            );
        }

        return super.getHeaderLeft(props);
    }

    public getHeaderRight(props: Props): React.ReactElement {
        const { index, nextProduct, previousProduct, hits, isMobile } = props;

        if (index >= 0 && isMobile) {
            return (
                <div className={styles.ProductDetailPage__navigation}>
                    {previousProduct ? (
                        <Link
                            className={styles.ProductDetailPage__navigation__previous}
                            to={url(bazaarProductDetailUrl, slugToParams(previousProduct.slug))}
                        >
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </Link>
                    ) : (
                        <span
                            className={cx(
                                styles.ProductDetailPage__navigation__previous,
                                styles["Navigation__navigation__previous--disabled"],
                            )}
                        >
                            {index > 0 ? (
                                <FontAwesomeIcon icon={faSpinner} spin />
                            ) : (
                                <FontAwesomeIcon icon={faChevronLeft} />
                            )}
                        </span>
                    )}
                    <div className={styles.ProductDetailPage__navigation__position}>
                        {formatThousands(index + 1)}
                    </div>
                    {nextProduct ? (
                        <Link
                            className={styles.ProductDetailPage__navigation__next}
                            to={url(bazaarProductDetailUrl, slugToParams(nextProduct.slug))}
                        >
                            <FontAwesomeIcon icon={faChevronRight} />
                        </Link>
                    ) : (
                        <span
                            className={cx(
                                styles.ProductDetailPage__navigation__next,
                                styles["Navigation__navigation__next--disabled"],
                            )}
                        >
                            {index + 1 < hits ? (
                                <FontAwesomeIcon icon={faSpinner} spin />
                            ) : (
                                <FontAwesomeIcon icon={faChevronRight} />
                            )}
                        </span>
                    )}
                </div>
            );
        }

        return super.getHeaderRight(props);
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return {
            activeSection: app,
            activeItem: null,
        };
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer("containers.bazaar.navigation", navigationReducer);
        store.injectSaga("containers.bazaar.navigation", navigationSaga);
        store.injectReducer("containers.bazaar.productDetail", reducer);
        store.injectSaga("containers.bazaar.productDetail", saga);
        store.injectReducer("containers.bazaar.isSoldPoll", isSoldPollReducer);
        store.injectSaga("containers.bazaar.isSoldPoll", isSoldPollSaga);
    }

    public getBrandingProps(props: Props): BrandingProps {
        if (props.isMobile) {
            // Mobile branding is rendered inside ProductInfo (between labels and description)
            return null;
        }
        return { zone: "Market Item - Top 01 - Desktop" };
    }

    public getInterstitialProps(props: Props): InterstitialProps | null {
        return { zone: "Market Item - Interstitial" };
    }

    public getAnchorLeaderboardProps(props: Props): AnchorLeaderboardProps {
        const { requestUser, isMobile } = props;

        if (!isMobile || (requestUser && !hasAds(requestUser))) {
            return null;
        }

        return {
            zone: "Market Item - Anchor - Mobile",
        };
    }

    public getStructuredData(props: Props): object[] {
        const { baseUrl, product } = props;

        if (!product) {
            return super.getStructuredData(props);
        }

        const categoryProp = product.properties.find((prop) => prop[0] === "cat");
        const category = categoryProp && dict()[categoryProp[1]];

        return [
            breadcrumbsProduct(
                baseUrl,
                category && isLeafCategory(category) ? category : null,
                product,
            ),
            productStructuredData(baseUrl, product),
        ];
    }
}
